<template lang="">
  <Layout>
    <template v-if="this.$route.name == 'add-payment-gatways'">
      <PageHeader :title="title1" :items="items"></PageHeader>
    </template>
    <template v-else>
      <PageHeader :title="title2" :items="items"></PageHeader>
    </template>
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <b-form enctype="multipart/form-data" ref="email" class="row">
              <b-form-group
                id="input-group-1"
                label-for="input-1"
                class="col-6"
              >
                <label>Name <span style="color: red">*</span></label>
                <b-form-input
                  id="input-1"
                  placeholder="Enter Name"
                  v-model="form.name"
                  :class="{
                    'is-invalid': submitted && $v.form.name.$error,
                  }"
                ></b-form-input>
                <div
                  v-if="submitted && !$v.form.product.required"
                  class="invalid-feedback"
                >
                  name is required.
                </div>
              </b-form-group>

              <b-form-group class="col-6">
                <label for="input-multi"
                  >Payment Gateway Type <span style="color: red">*</span></label
                >
                <b-form-select
                  v-model="form.payment_gateway_type_id"
                  :options="payment_gateway_type"
                  value-field="id"
                  text-field="name"
                  placeholder="select option"
                  :class="{
                    'is-invalid':
                      submitted && $v.form.payment_gateway_type_id.$error,
                  }"
                >
                </b-form-select>
                <div
                  v-if="submitted && !$v.form.product.required"
                  class="invalid-feedback"
                >
                  payment gateway type is required.
                </div>
              </b-form-group>

              <b-form-group
                id="input-group-1"
                label-for="input-1"
                class="col-6"
              >
                <label>slug <span style="color: red">*</span></label>
                <b-form-input
                  id="input-1"
                  placeholder="Enter slug"
                  v-model="form.slug"
                  :class="{
                    'is-invalid': submitted && $v.form.slug.$error,
                  }"
                ></b-form-input>
                <div
                  v-if="submitted && !$v.form.product.required"
                  class="invalid-feedback"
                >
                  slug is required.
                </div>
              </b-form-group>

              <b-form-group
                id="input-group-1"
                label-for="input-1"
                class="col-6"
              >
                <label>config <span style="color: red">*</span></label>
                <b-form-input
                  id="input-1"
                  placeholder="Enter config"
                  v-model="form.config"
                  :class="{
                    'is-invalid': submitted && $v.form.config.$error,
                  }"
                ></b-form-input>
                <div
                  v-if="submitted && !$v.form.product.required"
                  class="invalid-feedback"
                >
                  config is required.
                </div>
              </b-form-group>

              <b-form-group class="col-6">
                <label for="multi_event" style="font-weight: 500"
                  >Product <span style="color: red">*</span></label
                >
                <multiselect
                  id="item"
                  :options="getProduct"
                  v-model="form.product"
                  :multiple="true"
                  track-by="id"
                  label="name"
                  placeholder="Type here to search"
                  :class="{
                    'is-invalid': submitted && $v.form.product.$error,
                  }"
                >
                  <span slot="noOptions"> Type here to search </span>
                </multiselect>
                <div
                  v-if="submitted && !$v.form.product.required"
                  class="invalid-feedback"
                >
                  product is required.
                </div>
              </b-form-group>

              <b-form-group
                id="input-group-1"
                label-for="input-1"
                class="col-12"
              >
                <label>Description <span style="color: red">*</span></label>
                <ckeditor
                  v-model="form.description"
                  :editor="editor"
                  :class="{
                    'is-invalid': submitted && $v.form.description.$error,
                  }"
                ></ckeditor>
                <div
                  v-if="submitted && !$v.form.product.required"
                  class="invalid-feedback"
                >
                  description is required.
                </div>
              </b-form-group>

              <b-form-group
                id="input-group-1"
                label-for="input-1"
                class="col-12"
              >
                <b-form-checkbox @input="changestatus" v-model="form.status"
                  >is active</b-form-checkbox
                >
              </b-form-group>

              <div class="col-12">
                <b-button
                  type="submit"
                  variant="primary"
                  class="mr-2"
                  @click.prevent="submitData"
                  ><span v-if="this.$route.name == 'add-payment-gatways'"
                    >Save Data</span
                  >
                  <span v-else>Update Data</span>
                </b-button>
              </div>
            </b-form>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
<script>
import Layout from "../../../layouts/main.vue";
import PageHeader from "@/components/page-header";
import MixinRequest from "../../../../mixins/request";
import gatwayMixin from "../../../../mixins/ModuleJs/payment-gateways";
import { required } from "vuelidate/lib/validators";
import Multiselect from "vue-multiselect";
import CKEditor from "@ckeditor/ckeditor5-vue2";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";

export default {
  mixins: [MixinRequest, gatwayMixin],
  data() {
    return {
      editor: ClassicEditor,
      title1: "ADD PAYMENT GATEWAYS",
      title2: "EDIT PAYMENT GATEWAYS",
      items: [
        {
          text: "Back",
          href: "/payment-gatways",
        },
        {
          text: "Data",
        },
      ],
    };
  },
  components: {
    ckeditor: CKEditor.component,
    Layout,
    PageHeader,
    Multiselect,
  },
  validations: {
    form: {
      name: { required },
      payment_gateway_type_id: { required },
      description: { required },
      slug: { required },
      product: { required },
      config: {
        required,
        isValidJSON(value) {
          try {
            JSON.parse(value);
            return true;
          } catch (error) {
            return false;
          }
        },
      },
    },
  },
};
</script>
